<template>
  <div class="split-section d-flex flex-wrap login-page">
    <info></info>
    <div
      class="right-infosec d-flex align-items-center text-center flex-wrap justify-content-center"
    >
      <div class="signup-form">
        <h2>Sign Up</h2>
        <div class="signup-options">
          <p>
            <span>Sign up with,</span>
          </p>
          <!-- <span class="spinner-border" role="status" aria-hidden="true" style="width: 3rem; height: 3rem;color:#FD3E75;" v-if="showSpinner === true"></span> -->
          <a
            href="#"
            class="btn btn-fb"
            @click="loginWithFacebook"
            :disabled="fbButtonDisable === true"
          >{{ fbButtonText }}</a>
          <p>
            <span>or</span>
          </p>
        </div>
        <div class="gr-form">
          <p>Sign up with email,</p>
          <!-- <div class="user-details">
            <div class="profile-img">
              <img :src="cropped" v-if="cropped" class="profile-image" />
              <img src="../../../public/assets/images/defaultUser.png" v-else />
            </div>

            <input type="file" ref="file" style="display:none" @change="changeProfilePic" />
            <a href="#" @click="$refs.file.click()">Change profile image</a>
          </div>-->
          <form @submit="signUp" name="signUpForm">
            <div class="form-group">
              <label for="first-name" class="f-name">First Name</label>
              <input
                type="text"
                class="form-control"
                id="name"
                v-model="firstName"
                name="firstName"
                data-vv-as="First name"
                v-validate="'required|min:2|max:500|nameFormat'"
              />
              <span class="invalid-feedback">{{ errors.first('firstName') }}</span>
            </div>
            <div class="form-group">
              <label for="last-name" class="l-name">Last Name</label>
              <input
                type="text"
                class="form-control"
                id="lname"
                v-model="lastName"
                name="lastName"
                data-vv-as="Last name"
                v-validate="'required|min:2|max:500|nameFormat'"
              />
              <span class="invalid-feedback">{{ errors.first('lastName') }}</span>
            </div>
            <div class="form-group">
              <label for="email" class="email">Email</label>
              <input
                type="text"
                class="form-control"
                id="email"
                v-model="email"
                name="email"
                data-vv-as="Email"
                v-validate="'required|email'"
              />
              <span class="invalid-feedback">{{ errors.first('email') }}</span>
            </div>
            <div class="form-group">
              <label for="phone" class="ph-number">Phone number</label>
              <input
                type="text"
                class="form-control"
                id="pnumber"
                v-model="phoneNumber"
                name="phoneNumber"
                data-vv-as="Phone number"
                v-validate="'min:10|phoneFormat'"
              />
              <span class="invalid-feedback">{{ errors.first('phoneNumber') }}</span>
            </div>
            <div class="form-group">
              <label for="password" class="password">Password</label>
              <input
                :type="passwordFieldType"
                class="form-control"
                id="password"
                v-model="password"
                name="password"
                ref="password"
                data-vv-as="Password"
                v-validate="'required|passwordFormat'"
              />

              <span toggle="#password" :class="passwordShowIcon" @click="switchPasswordVisibility"></span>

              <span class="invalid-feedback">{{ errors.first('password') }}</span>
            </div>
            <div class="form-group">
              <label for="password" class="repeat-password">Repeat password</label>
              <input
                :type="repeatPasswordFieldType"
                class="form-control"
                id="repeat-password"
                v-model="repeatPassword"
                name="repeatPassword"
                ref="repeatPassword"
                v-validate="'required|confirmed:password'"
              />

              <span
                toggle="#repeat-password"
                :class="repeatPasswordShowIcon"
                @click="switchRepeatPasswordVisibility"
              ></span>

              <span class="invalid-feedback">{{ errors.first('repeatPassword') }}</span>
            </div>
            <div
              class="alert alert-primary alert-dismissible"
              role="alert"
              v-show="apiSuccessMessage"
            >
              {{apiSuccessMessage}}
              <img
                class="close"
                src="assets/images/close.svg"
                data-dismiss="alert"
                aria-label="close"
              />
            </div>
            <div class="alert alert-danger alert-dismissible" role="alert" v-if="showAlertMessage">
              {{apiErrorMessage}}
              <img
                class="close"
                src="assets/images/close.svg"
                data-dismiss="alert"
                aria-label="close"
                @click="showAlertMessage=!showAlertMessage"
              />
            </div>
            <button
              type="submit"
              class="btn btn-primary"
              :disabled="disabled == true"
            >{{buttonText}}</button>
            <div class="form-note text-center">
              By signing up you are agreeing to our
              <router-link href="#" to="/termsConditions">terms and conditions</router-link>, Already have an account? you can sign in
              <router-link to="/">here</router-link>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!--Modal start -->
    <!-- <div
            class="modal more-guest-list"
            id="cropImageModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="cropImageModal"
            aria-hidden="true"
            :show="initialiseCropper()"
            ref="cropImageModal"
          >
            <div class="modal-dialog model-lg" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h3 class="modal-title">Crop Image</h3>
                  <img
                    class="close"
                    src="../../../public/assets/images/close.svg"
                    data-dismiss="modal"
                    aria-label="Close"
                  />
                </div>
                <div class="modal-body">
                  <vue-croppie
                    ref="croppieRef"
                    :enableOrientation="true"
                    :enforceBoundary="false"
                    :enableResize="false"
                    @result="result"
                    @update="update"
                    :enableExif="true"
                    :mouseWheelZoom="false"
                    :enableKeyMovement="true"
                    :showZoomer="true"
                    :viewport="{ width: 300, height: 215, type: 'square' }"
                    :boundry="{ width: 600, height: 430}"
                  ></vue-croppie>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    v-if="imagePreview && !cropped"
                    class="btn btn-primary crop-button"
                    @click="crop()"
                  >Crop</button>
                </div>
              </div>
            </div>
    </div>-->
    <!-- Modal end -->
  </div>
</template>

<script>
import {
  SIGN_UP,
  SIGN_UP_WITH_FACEBOOK,
  LOGIN,
  SAVE_TOKEN,
  SET_USER_LOGGED
} from "../../store/auth/action.type";
import Info from "./Info";
import "../../plugins/fb-sdk";
import { SAVE_UPDATED_PROFILE_IMAGE } from "../../store/user/action.type";

export default {
  components: { info: Info },

  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      password: "",
      repeatPassword: "",
      apiSuccessMessage: "",
      apiErrorMessage: "",
      sharedEvent: null,
      sharedEventId: false,
      showPassword: false,
      showRepeatPassword: false,
      showAlertMessage: false,
      buttonText: "Sign Up",
      disabled: false,
      passwordFieldType: "password",
      passwordShowIcon: "fa fa-fw fa-eye field-icon toggle-password",
      repeatPasswordFieldType: "password",
      repeatPasswordShowIcon: "fa fa-fw fa-eye field-icon toggle-password",
      showSpinner: false,
      fbButtonDisable: false,
      fbButtonText: "Facebook"

      //for user profile image
      // cropped: null,
      // file: "",
      // imagePreview: null,
      // showPreview: false
    };
  },
  created() {
    this.$validator.extend("passwordFormat", {
      getMessage: () =>
        "Password must contain at least one uppercase, lowercase, digit and 8 characters long",
      validate: value =>
        value.match(
          /^(?=.*[A-Z])(?=.*\d)(?=.*[a-z])[A-Za-z\d@$!%*#?&]{8,}$/
        ) !== null
    });
    this.$validator.extend("phoneFormat", {
      getMessage: () =>
        "Phone number must contain number and atleast 10 characters long",
      validate: value => value.match(/^[0-9,+]*$/) !== null
    });
    this.$validator.extend("nameFormat", {
      getMessage: field =>
        `${field} must not contain special character or numbers`,
      validate: value => value.match(/^[a-zA-Z_ ]*$/) !== null
    });
    this.sharedEvent = JSON.parse(localStorage.getItem("sharedEvent"));
    this.sharedEventId = localStorage.getItem("sharedEventId");
  },
  methods: {
    // signUp(e) {
    //   e.preventDefault();
    //   this.$validator.validateAll().then(valid => {
    //     if(valid) {
    //       if(this.cropped != null) {
    //         this.saveProfileImage();
    //       }
    //       else {
    //         this.saveUserData();
    //       }
    //     }
    //   })
    // },

    //     saveProfileImage() {
    // let uploadedImage = {
    //         image: this.cropped
    //       };
    //       if (this.cropped) {
    //         this.$store
    //           .dispatch(SAVE_UPDATED_PROFILE_IMAGE, uploadedImage)
    //           .then(response => {
    //             if (response.status == 200) {
    //               this.cropped = response.data.data.file;
    //             } else {
    //               this.showAlertMessage = true;
    //               this.apiErrorMessage = response.data.message;
    //             }
    //             this.saveUserData();
    //           })
    //           .catch(error => {
    //             console.log(error)
    //             this.showAlertMessage = true;
    //             this.apiErrorMessage = error.response.data.message;
    //           });
    //       }
    //     },

    signUp(e) {
      e.preventDefault();
      this.firstName = this.capitalizeFirstLetter(this.firstName);
      this.lastName = this.capitalizeFirstLetter(this.lastName);
      const userDetails = {
        name: this.firstName + " " + this.lastName,
        email: this.email,
        phoneNumber: this.phoneNumber,
        password: this.password
      };
      // if(this.cropped) {
      //   userDetails.profileImage = this.cropped
      // }
      this.$validator.validateAll().then(valid => {
        if (valid) {
          // this.showSpinner = true;
          this.disabled = true;
          this.buttonText = "Please wait...";
          this.$store
            .dispatch(SIGN_UP, userDetails)
            .then(response => {
              if (response.status != 200) {
                this.showAlertMessage = true;
                this.apiErrorMessage = response.data.message;
                this.apiSuccessMessage = null;
              } else {
                this.apiSuccessMessage = response.data.message;
                this.apiErrorMessage = null;
                const clear = async () => {
                  const userDetails = {
                    email: this.email,
                    password: this.password
                  };
                  this.$store.dispatch(LOGIN, userDetails).then(response => {
                    if (response.status == 200) {
                      let token = {
                        accessToken: response.headers.accesstoken,
                        refreshToken: response.headers.refreshtoken
                      };
                      this.$store.dispatch(SAVE_TOKEN, token);
                    }
                  });

                  this.firstName = "";
                  this.lastName = "";
                  this.email = "";
                  this.phoneNumber = "";
                  this.password = "";
                  this.repeatPassword = "";
                  this.$router.push({ path: "/" });
                };
                clear().then(() => {
                  this.$validator.reset();
                });
              }
              this.disabled = false;
              this.buttonText = "Sign Up";
            })
            .catch(error => {
              this.showAlertMessage = true;
              this.disabled = false;
              this.buttonText = "Sign Up";
              this.apiErrorMessage = error.response.data.message;
              this.apiSuccessMessage = null;
            });
        }
      });
    },
    loginWithFacebook(e) {
      e.preventDefault();
      let self = this;
      // self.fbButtonDisable = true;
      // self.fbButtonText = "Please wait...";
      FB.login(function(response) {
        if (response.authResponse) {
          self.$store
            .dispatch(SIGN_UP_WITH_FACEBOOK, response.authResponse.accessToken)
            .then(response => {
              if (response.status == 200) {
                setTimeout(() => {
                   self.fbButtonDisable = true;
                }, 2000);
                localStorage.setItem(
                  "GiftRegistryAccessToken" +
                    process.env.VUE_APP_ACCESS_TOKEN_NAME,
                  response.headers.accesstoken
                );
                localStorage.setItem(
                  "GiftRegistryRefreshToken" +
                    process.env.VUE_APP_ACCESS_TOKEN_NAME,
                  response.headers.refreshtoken
                );
                self.$store.dispatch(SET_USER_LOGGED, true);
                self.apiSuccessMessage = response.data.message;
                setTimeout(() => {
                  self.fbButtonDisable = true;
                  self.fbButtonText = "Facebook";
                  self.$router.push({ path: "/dashboard" });
                }, 2000);
              } else {
                self.fbButtonDisable = false;
                self.fbButtonText = "Facebook";
                self.apiErrorMessage = response.data.message;
                self.showAlertMessage = true;
              }
            })
            .catch(error => {
              self.fbButtonDisable = false;
              self.fbButtonText = "Facebook";
              self.apiErrorMessage = error;
              self.showAlertMessage = true;
            });
          console.log("Welcome!  Fetching your information.... ");
          FB.api("/me", function(response) {
            console.log("Good to see you, " + response.name + ".");
          });
        } else {
          console.log("User cancelled login or did not fully authorize.");
        }
      });
    },

    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.substring(1).toLowerCase();
    },

    switchPasswordVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
      this.passwordShowIcon =
        this.passwordShowIcon === "fa fa-fw fa-eye field-icon toggle-password"
          ? "fa fa-fw fa-eye-slash field-icon toggle-password"
          : "fa fa-fw fa-eye field-icon toggle-password";
    },

    switchRepeatPasswordVisibility() {
      this.repeatPasswordFieldType =
        this.repeatPasswordFieldType === "password" ? "text" : "password";
      this.repeatPasswordShowIcon =
        this.repeatPasswordShowIcon ===
        "fa fa-fw fa-eye field-icon toggle-password"
          ? "fa fa-fw fa-eye-slash field-icon toggle-password"
          : "fa fa-fw fa-eye field-icon toggle-password";
    }

    //for user profile image
    // refresh() {
    //   this.$refs.croppieRef.destroy();
    // },
    // initCroppie() {
    //   this.$refs.croppieRef.initCroppie();
    // },
    // result(output) {
    //   this.cropped = output;
    // },
    // update(val) {
    //   // console.log(val);
    // },
    // initialiseCropper() {
    //   if (this.$refs.croppieRef) {
    //     this.$refs.croppieRef.bind({
    //       url: this.imagePreview
    //     });
    //   }
    //   console.log(this.imagePreview)
    // },

    // changeProfilePic() {
    //   this.refresh();
    //   this.initCroppie();
    //   this.cropped = null;
    //   this.file = this.$refs.file.files[0];
    //   let reader = new FileReader();
    //   reader.addEventListener(
    //     "load",
    //     function() {
    //       this.showPreview = true;
    //       this.imagePreview = reader.result;
    //       this.$refs.file.value = "";
    //       $("#cropImageModal").modal("show");
    //     }.bind(this),
    //     false
    //   );
    //   if (this.file) {
    //     if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
    //       reader.readAsDataURL(this.file);
    //     }
    //   }
    // },
    // crop() {
    //   let options = {
    //     format: "jpeg",
    //     circle: true
    //   };

    //   this.$refs.croppieRef.result(options, output => {
    //     this.cropped = output;
    //     // this.showSpinner = true;
    //   });
    //   $("#cropImageModal").modal("hide");
    // },
  }
};
</script>
<style scoped>
.btn-primary:disabled {
  background-color: transparent;
  color: #fd3e75 !important;
  border: 0.0625rem solid #fd3e75 !important;
}
.user-details {
  text-align: center;
}
.profile-img {
  display: inline-block;
}
.profile-image {
  border-radius: 50%;
  height: 100%;
}
.d-flex >>> .left-infosec .leftblock-wrap {
  margin-top: -41%;
}
</style>
